import { render, staticRenderFns } from "./zujuan.vue?vue&type=template&id=78936efa&scoped=true"
import script from "./zujuan.vue?vue&type=script&lang=js"
export * from "./zujuan.vue?vue&type=script&lang=js"
import style0 from "./zujuan.vue?vue&type=style&index=0&id=78936efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78936efa",
  null
  
)

export default component.exports